import { Button, FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput } from '@/components'
import { MouseEvent } from 'react'
import useModalStore from '@/store/modal'

function CopyUrlBox ( props ) {
    const { url } = props
    const { setMessageProps } = useModalStore()
    const onCopyUrl = ( e: MouseEvent<HTMLButtonElement> ) => {
        navigator.clipboard.writeText( url )

        setMessageProps( {
            isOpen: true,
            message: '복사되었습니다.',
            severity: 'success'
        } )
    }

    return (
        <FormControl
            sx={ { width: '100%' } }
            variant="outlined"
        >
            <InputLabel>URL</InputLabel>
            <OutlinedInput
                readOnly
                label="Password"
                value={ url }
                endAdornment={
                    <InputAdornment position="end">
                        <Button
                            variant="contained"
                            onClick={ onCopyUrl }
                        >
                            복사
                        </Button>
                    </InputAdornment>
                }
            />
            <FormHelperText>{ 'test' }</FormHelperText>
        </FormControl>
    )
}

export default CopyUrlBox